import configureYousersJS from './configure-yousersjs';

export default {
  configureYousersJS,
};
